// Local config fallback - removed problematic JSON import that caused build errors

// API Configuration - production ready
const API_CONFIG = {
  baseUrl: window.location.origin + '/api/v1', // dynamicky podle aktuální domény
  auth: {
    username: "merlinapi",
    password: "3AJRr0oKU2Bs0aN1hVsifkhK6lr1p6BQ9jEnN8wAQo",
  },
};

/**
 * ApiManager handles all API operations including articles, files, and configuration loading
 */
export class ApiManager {
  constructor() {
    this.credentials = btoa(
      `${API_CONFIG.auth.username}:${API_CONFIG.auth.password}`,
    );
  }

  /**
   * Fetch articles from the API
   * @returns {Promise<Array>} Array of articles
   */
  async fetchArticles() {
    try {
      const response = await fetch(`${API_CONFIG.baseUrl}/articles`, {
        method: "GET",
        headers: {
          Authorization: `Basic ${this.credentials}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const articles = await response.json();
      console.log("[Articles] fetched successfully:", articles);
      return articles;
    } catch (error) {
      console.error("Error fetching articles:", error);
      throw error;
    }
  }

  /**
   * Fetch files from the API
   * @param {string|null} nameFilter - Optional name filter
   * @returns {Promise<Array>} Array of files
   */
  async fetchFiles(nameFilter = null) {
    try {
      // Build URL with query parameters
      let url = `${API_CONFIG.baseUrl}/file-categories/3/files`;
      if (nameFilter) {
        const params = new URLSearchParams();
        params.append("filter[name]", nameFilter);
        url += `?${params.toString()}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Basic ${this.credentials}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const files = await response.json();
      console.log("[Files] fetched successfully:", files);
      return files;
    } catch (error) {
      console.error("Error fetching files:", error);
      throw error;
    }
  }

  /**
   * Load step configuration from various possible sources
   * @returns {Promise<Object>} Configuration object
   */
  async loadStepConfig() {
    const randomNumber = Math.floor(Math.random() * 901) + 100;
    const randomLetters = Math.random().toString(36).substring(2, 5).toUpperCase();
    const randomString = `${randomNumber}${randomLetters}`;
    try {
      // Try different possible paths for the config file
      const possiblePaths = [
        `/public/files/web/config.json?v=C${randomString}`,
        `/public/files/web/config(1).json?v=C${randomString}`,
      ];

      for (const path of possiblePaths) {
        try {
          const response = await fetch(path);
          if (response.ok) {
            const config = await response.json();
            console.log(`Configuration loaded successfully from: ${path}`);
            return config;
          }
        } catch (error) {
          console.warn(`Failed to load config from ${path}:`, error.message);
        }
      }

      // If API paths fail, try to load config from alternative paths
      console.log("API paths failed, attempting alternative paths...");

      const alternativePaths = [
        `/src/config.json?v=${randomNumber}`,
        `./src/config.json?v=${randomNumber}`,
        `../config.json?v=${randomNumber}`,
        `./config.json?v=${randomNumber}`
      ];

      for (const path of alternativePaths) {
        try {
          const response = await fetch(path);
          if (response.ok) {
            const config = await response.json();
            console.log(`Configuration loaded successfully from alternative path: ${path}`);
            return config;
          }
        } catch (error) {
          console.warn(`Failed to load config from alternative path ${path}:`, error.message);
        }
      }

      throw new Error("No valid configuration source available");
    } catch (error) {
      console.error("Failed to load configuration:", error);

      // Final fallback - return a minimal config to prevent complete failure
      console.warn("Using emergency fallback configuration");
      return {
        steps: [
          {
            id: 1,
            name: "fallback",
            type: "image",
            background: {
              type: "image",
              src: "/public/assets/fallback.jpg",
            },
          },
        ],
      };
    }
  }

  /**
   * Get API configuration
   * @returns {Object} API configuration object
   */
  getApiConfig() {
    return { ...API_CONFIG };
  }

  /**
   * Update API configuration
   * @param {Object} newConfig - New configuration object
   */
  updateApiConfig(newConfig) {
    Object.assign(API_CONFIG, newConfig);
    this.credentials = btoa(
      `${API_CONFIG.auth.username}:${API_CONFIG.auth.password}`,
    );
  }
}

// Export singleton instance
export const apiManager = new ApiManager();
